<template>
  <div>
    <b-card class="mt-4">
      <b-card-body class="p-2">
        <div v-if="charttype == 'line'">
          <line-chart :xyfiellds="xyfiellds" :title="title" :url="url"></line-chart>
        </div>
      </b-card-body>
    </b-card>
  </div>
</template>
<script>
import lineChart from "./designs/lineChart.vue";
export default {
  name: "chartComponent",
  props: ["url", "charttype", "title", "xyfiellds"],
  components: { "line-chart": lineChart },
  data() {
    return {};
  },
  mounted() {},
};
</script>